/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { InerestOverrideTableHead } from './TableHead';
import { getInterestOverrideReports } from '../Store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';
import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import { monthMapping } from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { exportAllPDF } from '../../../../SharedModules/pdfExport/exportAll';
import {
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';

const InterestOverrideDetail = (props) => {
  const dispatch = useDispatch();

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector((state) => state?.sharedState?.SharedReducer?.logInUser);

  const {
    isLoading,
    rebateProgramList,
    displayObj: {
      rebateProgramValue,
      fromDateValue,
      toDateValue,
      searchResult,
      rebateProgrameName,
    },
  } = useSelector((state) => state?.sharedState?.InterestOverrideReducer);
  const [rows, setRows] = React.useState([]);

  const [filteredRows, setFilteredRow] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [reportData, setReportData] = React.useState({});
  const [columnApi, setColumnApi] = React.useState(null);
  const [count, setCount] = React.useState(1);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [paginationArray, setPaginationArray] = React.useState([]);

  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgrameName;
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${rebateProgramNameValue?.rebateProgramCd} - ${
  //   rebateProgramNameValue?.shortDescr || ''
  // }`;

  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Function handle the next previous button actions on click
  const handleClick = (type, value) => {
    if (type === 'next') {
      setCount(count + 1);
    }

    if (type === 'previous') {
      setCount(count - 1);
    }

    if (type === 'change') {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        setCount(value);
      }
    }
  };

  // Function handle the next previous button actions on blur
  const handleBlur = (value) => {
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   setCount(0);
    //   setTimeout(() => {
    //     value < 1 ? setCount(1) : setCount(paginationArray.length);
    //   }, 20);
    // } else {
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      setCount(parseInt(value));
    }
  };

  // Interest override api call at initial load
  React.useEffect(() => {
    let beginDate = quarterToDate(fromDateValue);
    let endDate =
      quarterToDate(toDateValue, 'toDate') || quarterToDate(fromDateValue);
    if (beginDate.includes('/')) {
      const splittedBD = beginDate.split('/');
      beginDate = `${splittedBD[0]}-${monthMapping[splittedBD[0]]}-${
        splittedBD[2]
      }`;
    }
    if (endDate.includes('/')) {
      const splittedED = endDate.split('/');
      endDate = `${splittedED[0]}-${monthMapping[splittedED[0]]}-${
        splittedED[2]
      }`;
    }
    dispatch(
      getInterestOverrideReports({
        asRpc: rebateProgramValue,

        adBegin: beginDate,
        adEnd: endDate,
      })
    );
  }, []);
  const groupBy = function (xs, key) {
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  // Set the table data rows
  React.useEffect(() => {
    let data = searchResult;
    data = data.map((item) => {
      const qtr = `${item.qtrInvoiced?.substring(
        4,
        5
      )}Q${item.qtrInvoiced?.substring(0, 4)}`;
      return {
        ...item,
        qtrInvoiced: qtr,
        dateChanged: moment(new Date(item.dateChanged)).format('MM/DD/YYYY'),
        interestAmt: parseFloat(item?.interestAmt?.toFixed(2)),
      };
    });
    const groupedData = groupBy(data, 'labelercd');

    const keys = Object.keys(groupedData);
    setPaginationArray([...Array(keys.length).keys()]);
    setReportData(groupedData);
  }, [searchResult]);

  React.useEffect(() => {
    const keys = Object.keys(reportData);
    keys.sort();
    reportData[keys[count - 1]]
      ? setRows(reportData[keys[count - 1]])
      : setRows([]);
  }, [count, reportData]);

  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  /*
    Below threee functions are for calculating data of table bottom pinned row
  */
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : rows;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
      return data ;

  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i++) {
      result.push({
        isBottomRow: true,
        interestAmt: sum('interestAmt'),

        drugName: 'Total Interest Change Amount:',
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rows, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  const onGridReady = (params) => {
    setColumnApi(params?.columnApi);
  };

  const exportAllTpPDF = (name) => {
    if (!reportData || Object.keys(reportData).length === 0) return;
    const header = {
      reportName: 'Interest Override Report',
      fileName: name || 'InterestOverride',
    };

    const mapping = {};
    Object.keys(reportData).forEach((key) => {
      const item = reportData[key] && reportData[key][0];
      mapping[key] = item
        ? `${item.mfgName || ''} (${item.labelercd || key})`
        : key;
    });

    const paginationArr = Object.keys(reportData).sort();

    const options = {
      info: { secondInfo, thirdInfo, fourthInfo },
  titleName: 'Manufacturer Name: ',
      mapping,
      pageSize: { height: 800, width: 2000 },
    };

    options.totalPages = paginationArr.length;

    const widths = [];

      exportAllPDF(
        header,
        reportData,
        columnApi,
        userDefaults,
        options,
        paginationArr,
        widths,
        logInUser
      );
  };

  let fromDate = fromDateValue;
  let toDate = toDateValue;
  if (fromDateValue.includes('Q')) {
    fromDate = convertStringDate(quarterToDate(fromDateValue, 'fromDate'));
  }
  if (toDateValue.includes('Q')) {
    toDate = convertStringDate(quarterToDate(toDateValue, 'toDate'));
  }
  const dateToShow = `${fromDate}-${toDate || fromDate}`;

  // Below 4 variable for PDF header slected information
  const firstInfo = `Mfg: ${rows[0]?.labelercd} ${rows[0]?.mfgName}`;
  const secondInfo = `Date Range: ${dateToShow} `;
  const thirdInfo = rebateProgramNameValue;
  const fourthInfo = '';
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Interest Override Display"
      />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Manufacturer Id: "
                          id="Manufacturer Id:"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rows[0]?.labelercd}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Manufacturer Name: "
                          id="Manufacturer Name: "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rows[0]?.mfgName}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program: "
                          id="Rebate Program: "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramNameValue}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Date Range: "
                          id="Date Range: "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={`${dateToShow}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div
            className="unallocated bottom-pinned-bold"
            style={{ width: '100vw' }}
          >
            <TableGridWithFeatures
              gridHeight={viewPortHeight_355}
              columnDefs={InerestOverrideTableHead}
              rowData={rows}
              data-testid="onEditingStopped"
              enterMovesDown
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              hideTotalCount={false}
              exportFile
              onFilterData={onFilterChanged}
              fileName="InterestOverride"
              reportName="Interest Override Report"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
              pinnedBottomRowData={pinnedBottomRowData}
              getFilterApply={getFilterApply}
              isScrollOn
              defaultColWidth={200}
              gridCall={onGridReady}
              exportAllTpPDF={paginationArray.length > 1 ? exportAllTpPDF : null}
              
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name}`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterestOverrideDetail;
